import { Link } from "react-router-dom";

export const SectionLabel = ({ children, className = "" }) => (
  <p
    className={`font-mono text-xs font-medium uppercase tracking-[0.22em] text-accent ${className}`}
  >
    {children}
  </p>
);

export const Tag = ({ children, testid }) => (
  <span
    data-testid={testid}
    className="inline-flex items-center rounded-full border border-line bg-lavender px-3 py-1 text-xs font-medium text-plum"
  >
    {children}
  </span>
);

export const ButtonLink = ({
  to,
  children,
  variant = "primary",
  testid,
  className = "",
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all duration-200";
  const styles =
    variant === "primary"
      ? "bg-plum text-white hover:bg-ink hover:-translate-y-0.5"
      : "border border-line bg-transparent text-ink hover:border-plum hover:text-plum hover:-translate-y-0.5";
  return (
    <Link data-testid={testid} to={to} className={`${base} ${styles} ${className}`}>
      {children}
    </Link>
  );
};

export const ActionButton = ({
  onClick,
  children,
  variant = "primary",
  testid,
  type = "button",
  disabled,
  className = "",
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed";
  const styles =
    variant === "primary"
      ? "bg-plum text-white hover:bg-ink hover:-translate-y-0.5"
      : variant === "quiet"
      ? "border border-line bg-transparent text-ink hover:border-plum hover:text-plum"
      : "border border-line bg-transparent text-ink hover:border-plum hover:text-plum hover:-translate-y-0.5";
  return (
    <button
      data-testid={testid}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${styles} ${className}`}
    >
      {children}
    </button>
  );
};

export const SectionDivider = () => (
  <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <hr className="border-line" />
  </div>
);

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="logo-home-link" className="group flex items-center gap-3">
    <span
      className={`flex h-10 w-10 items-center justify-center rounded-xl border border-line bg-lavender font-serif text-base font-bold text-plum transition-colors duration-200 group-hover:bg-plum group-hover:text-white ${
        light ? "" : ""
      }`}
    >
      ss<span className="text-accent group-hover:text-lavender">.</span>
    </span>
    <span className="leading-tight">
      <span className="block font-serif text-lg font-semibold text-ink">
        Savvy Stephanie
      </span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.18em] text-accent">
        Analytics &amp; Consulting
      </span>
    </span>
  </Link>
);
